import { useState, useRef, useEffect } from 'react';

import Loader from '@/components/common/Loader';

import { useApplication } from '@/data/application';

const ApplicationSteps = ({ steps }) => {
  const stepRefs = useRef([]);
  const [lineHeights, setLineHeights] = useState([]);
  const observerRef = useRef(null);

  useEffect(() => {
    // Initialize the ResizeObserver
    observerRef.current = new ResizeObserver(() => {
      const heights = steps.slice(0, -1).map((_, index) => {
        if (!stepRefs.current[index] || !stepRefs.current[index + 1]) return 0;
        return (
          stepRefs.current[index + 1].offsetTop -
          stepRefs.current[index].offsetTop -
          16
        );
      });
      setLineHeights(heights);
    });

    // Observe each step element
    stepRefs.current.forEach((ref) => {
      if (ref) {
        observerRef.current.observe(ref);
      }
    });

    // Cleanup
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [steps]);

  return (
    <div className="py-6">
      <ul className="space-y-4">
        {steps.map((step, index) => (
          <li
            key={index}
            className="relative"
            ref={(el) => {
              stepRefs.current[index] = el;
              if (el && observerRef.current) {
                observerRef.current.observe(el);
              }
            }}
          >
            <div className="flex items-start p-2 -m-2g">
              <div className="relative">
                <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold">{index + 1}</span>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className="absolute left-1/2 -translate-x-1/2 w-[1px] bg-muted-foreground"
                    style={{
                      top: '2rem',
                      height: `${lineHeights[index] || 0}px`
                    }}
                  />
                )}
              </div>
              <div className="ml-4 flex-grow">
                <h3 className="font-semibold text-lg">{step.title}</h3>
                <p className="text-muted-foreground text-sm">{step.subTitle}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const ApplicationStepsLoader = ({ activityId }) => {
  const applicationStructure = useApplication({ activityId });

  if (applicationStructure.isLoading && !applicationStructure.data) {
    return (
      <div className="flex justify-center items-center h-[200px]">
        <Loader />
      </div>
    );
  }

  return <ApplicationSteps steps={applicationStructure.data.steps} />;
};

export default ApplicationStepsLoader;
